export default __webpack_public_path__ + "static/discovery-7313ea889999bdee3a95cc66382bd53a.jpg";